export default {
  getTask: (state) => state.task,
  getTasksByStageId: (state) => (stageId) => {
    const result = state.tasks
      .filter((task) => task.stageId === stageId)
      .sort((a, b) => a.order - b.order);
    return result;
  },
};
